const map = {
	"./": 80815,
	"./account/de": 14039,
	"./account/de.json": 14039,
	"./account/en": 4751,
	"./account/en.json": 4751,
	"./account/fr": 94604,
	"./account/fr.json": 94604,
	"./account/it": 10133,
	"./account/it.json": 10133,
	"./app/de": 35467,
	"./app/de.json": 35467,
	"./app/en": 22723,
	"./app/en.json": 22723,
	"./app/fr": 60120,
	"./app/fr.json": 60120,
	"./app/it": 6337,
	"./app/it.json": 6337,
	"./assessments/de": 80291,
	"./assessments/de.json": 80291,
	"./assessments/en": 31435,
	"./assessments/en.json": 31435,
	"./assessments/fr": 58864,
	"./assessments/fr.json": 58864,
	"./assessments/it": 19753,
	"./assessments/it.json": 19753,
	"./authorization/de": 51805,
	"./authorization/de.json": 51805,
	"./authorization/en": 65777,
	"./authorization/en.json": 65777,
	"./authorization/fr": 91914,
	"./authorization/fr.json": 91914,
	"./authorization/it": 25427,
	"./authorization/it.json": 25427,
	"./books/de": 76152,
	"./books/de.json": 76152,
	"./books/en": 43588,
	"./books/en.json": 43588,
	"./books/fr": 79327,
	"./books/fr.json": 79327,
	"./books/it": 5866,
	"./books/it.json": 5866,
	"./consts": 15747,
	"./consts.js": 15747,
	"./course/de": 5537,
	"./course/de.json": 5537,
	"./course/en": 86037,
	"./course/en.json": 86037,
	"./course/fr": 62262,
	"./course/fr.json": 62262,
	"./course/it": 26767,
	"./course/it.json": 26767,
	"./courses/de": 27768,
	"./courses/de.json": 27768,
	"./courses/en": 32388,
	"./courses/en.json": 32388,
	"./courses/fr": 33631,
	"./courses/fr.json": 33631,
	"./courses/it": 54058,
	"./courses/it.json": 54058,
	"./errors/de": 13895,
	"./errors/de.json": 13895,
	"./errors/en": 89695,
	"./errors/en.json": 89695,
	"./errors/fr": 94172,
	"./errors/fr.json": 94172,
	"./errors/it": 40869,
	"./errors/it.json": 40869,
	"./events/de": 76789,
	"./events/de.json": 76789,
	"./events/en": 40153,
	"./events/en.json": 40153,
	"./events/fr": 87938,
	"./events/fr.json": 87938,
	"./events/it": 53979,
	"./events/it.json": 53979,
	"./index": 80815,
	"./index.js": 80815,
	"./lectures/de": 35259,
	"./lectures/de.json": 35259,
	"./lectures/en": 56435,
	"./lectures/en.json": 56435,
	"./lectures/fr": 27656,
	"./lectures/fr.json": 27656,
	"./lectures/it": 72785,
	"./lectures/it.json": 72785,
	"./player/de": 63921,
	"./player/de.json": 63921,
	"./player/en": 16069,
	"./player/en.json": 16069,
	"./player/fr": 86310,
	"./player/fr.json": 86310,
	"./player/it": 68415,
	"./player/it.json": 68415,
	"./post/de": 98144,
	"./post/de.json": 98144,
	"./post/en": 9180,
	"./post/en.json": 9180,
	"./post/fr": 13127,
	"./post/fr.json": 13127,
	"./post/it": 80514,
	"./post/it.json": 80514,
	"./posts/de": 72251,
	"./posts/de.json": 72251,
	"./posts/en": 52819,
	"./posts/en.json": 52819,
	"./posts/fr": 4968,
	"./posts/fr.json": 4968,
	"./posts/it": 41617,
	"./posts/it.json": 41617,
	"./program/de": 39390,
	"./program/de.json": 39390,
	"./program/en": 66150,
	"./program/en.json": 66150,
	"./program/fr": 51573,
	"./program/fr.json": 51573,
	"./program/it": 67024,
	"./program/it.json": 67024,
	"./support/de": 48767,
	"./support/de.json": 48767,
	"./support/en": 7687,
	"./support/en.json": 7687,
	"./support/fr": 96020,
	"./support/fr.json": 96020,
	"./support/it": 37069,
	"./support/it.json": 37069
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47223;